export default () => ({
  sectionActive: 0,
  transitionDone: true,
  init() {},
  handleChangeSection(id) {
    const oldSection = this.sectionActive;
		this.sectionActive = id;
    this.$nextTick(() => {
      if (id > 0) {
        this.$refs.mobileNavBackButton.focus();
      } else {
        this.$refs["mobileNavSectionButton" + oldSection].focus();
      }
    });
  }
});
